import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CountUpModule} from 'ngx-countup';
import {TabsModule} from 'ngx-tabset';
import {NgxScrollTopModule} from 'ngx-scrolltop';
import {StickyNavModule} from 'ng2-sticky-nav';
import {LightboxModule} from 'ngx-lightbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SlickCarouselModule} from 'ngx-slick-carousel';

import {ToastrModule} from 'ngx-toastr';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomePageOneComponent} from './components/pages/home-page-one/home-page-one.component';
import {HomePageTwoComponent} from './components/pages/home-page-two/home-page-two.component';
import {FooterComponent} from './blocks/footer/footer.component';
import {PreloaderComponent} from './components/common/preloader/preloader.component';
import {HomeoneAboutComponent} from './components/pages/home-page-one/homeone-about/homeone-about.component';
import {HomeoneMainBannerComponent} from './components/pages/home-page-one/homeone-main-banner/homeone-main-banner.component';
import {HeaderStyleOneComponent} from './components/common/header-style-one/header-style-one.component';
import {CategoriesStyleOneComponent} from './components/common/categories-style-one/categories-style-one.component';
import {FunfactsComponent} from './components/common/funfacts/funfacts.component';
import {HomeoneCoursesComponent} from './components/pages/home-page-one/homeone-courses/homeone-courses.component';
import {PartnerStyleOneComponent} from './components/common/partner-style-one/partner-style-one.component';
import {InstructorsStyleOneComponent} from './components/common/instructors-style-one/instructors-style-one.component';
import {BecomeInstructorPartnerComponent} from './components/common/become-instructor-partner/become-instructor-partner.component';
import {FeedbackStyleOneComponent} from './components/common/feedback-style-one/feedback-style-one.component';
import {BlogComponent} from './components/common/blog/blog.component';
import {HeaderStyleTwoComponent} from './components/common/header-style-two/header-style-two.component';
import {HometwoMainBannerComponent} from './components/pages/home-page-two/hometwo-main-banner/hometwo-main-banner.component';
import {HometwoAboutComponent} from './components/pages/home-page-two/hometwo-about/hometwo-about.component';
import {HometwoCoursesComponent} from './components/pages/home-page-two/hometwo-courses/hometwo-courses.component';
import {OurMissionComponent} from './components/common/our-mission/our-mission.component';
import {InstructorsStyleTwoComponent} from './components/common/instructors-style-two/instructors-style-two.component';
import {WebinarCountdownComponent} from './components/common/webinar-countdown/webinar-countdown.component';
import {StudentsFeedbackFormComponent} from './components/common/students-feedback-form/students-feedback-form.component';
import {HomePageThreeComponent} from './components/pages/home-page-three/home-page-three.component';
import {HomePageFourComponent} from './components/pages/home-page-four/home-page-four.component';
import {HomePageFiveComponent} from './components/pages/home-page-five/home-page-five.component';
import {HomePageSixComponent} from './components/pages/home-page-six/home-page-six.component';
import {HomePageSevenComponent} from './components/pages/home-page-seven/home-page-seven.component';
import {PartnerStyleTwoComponent} from './components/common/partner-style-two/partner-style-two.component';
import {OfferComponent} from './components/common/offer/offer.component';
import {CategoriesStyleTwoComponent} from './components/common/categories-style-two/categories-style-two.component';
import {HomethreeCoursesComponent} from './components/pages/home-page-three/homethree-courses/homethree-courses.component';
import {HomethreeAboutComponent} from './components/pages/home-page-three/homethree-about/homethree-about.component';
import {FeedbackFormComponent} from './components/common/feedback-form/feedback-form.component';
import {HomethreeMainBannerComponent} from './components/pages/home-page-three/homethree-main-banner/homethree-main-banner.component';
import {HeaderStyleThreeComponent} from './components/common/header-style-three/header-style-three.component';
import {HomefourMainBannerComponent} from './components/pages/home-page-four/homefour-main-banner/homefour-main-banner.component';
import {HomefourCoursesComponent} from './components/pages/home-page-four/homefour-courses/homefour-courses.component';
import {BoxesComponent} from './components/common/boxes/boxes.component';
import {FeedbackStyleTwoComponent} from './components/common/feedback-style-two/feedback-style-two.component';
import {HomefiveCoursesComponent} from './components/pages/home-page-five/homefive-courses/homefive-courses.component';
import {HomefiveMainBannerComponent} from './components/pages/home-page-five/homefive-main-banner/homefive-main-banner.component';
import {InstructorsStyleThreeComponent} from './components/common/instructors-style-three/instructors-style-three.component';
import {FeaturesComponent} from './components/common/features/features.component';
import {HomesixCoursesComponent} from './components/pages/home-page-six/homesix-courses/homesix-courses.component';
import {CategoriesStyleThreeComponent} from './components/common/categories-style-three/categories-style-three.component';
import {HomesixMainBannerComponent} from './components/pages/home-page-six/homesix-main-banner/homesix-main-banner.component';
import {HeaderStyleFourComponent} from './components/common/header-style-four/header-style-four.component';
import {HomesevenMainBannerComponent} from './components/pages/home-page-seven/homeseven-main-banner/homeseven-main-banner.component';
import {HomesevenCoursesComponent} from './components/pages/home-page-seven/homeseven-courses/homeseven-courses.component';
import {HowItWorksComponent} from './components/common/how-it-works/how-it-works.component';
import {AboutPageOneComponent} from './components/pages/about-page-one/about-page-one.component';
import {AboutPageTwoComponent} from './components/pages/about-page-two/about-page-two.component';
import {OurStoryComponent} from './components/common/our-story/our-story.component';
import {OurValuesComponent} from './components/common/our-values/our-values.component';
import {InstructorsPageOneComponent} from './components/pages/instructors-page-one/instructors-page-one.component';
import {InstructorsPageTwoComponent} from './components/pages/instructors-page-two/instructors-page-two.component';
import {InstructorsPageThreeComponent} from './components/pages/instructors-page-three/instructors-page-three.component';
import {InstructorsDetailsPageComponent} from './components/pages/instructors-details-page/instructors-details-page.component';
import {GalleryPageComponent} from './components/pages/gallery-page/gallery-page.component';
import {EventsPageComponent} from './components/pages/events-page/events-page.component';
import {EventsDetailsPageComponent} from './components/pages/events-details-page/events-details-page.component';
import {PricingPageComponent} from './components/pages/pricing-page/pricing-page.component';
import {FeedbackPageComponent} from './components/pages/feedback-page/feedback-page.component';
import {PartnerPageComponent} from './components/pages/partner-page/partner-page.component';
import {LoginPageComponent} from './components/pages/login-page/login-page.component';
import {RegisterPageComponent} from './components/pages/register-page/register-page.component';
import {FaqPageComponent} from './components/pages/faq-page/faq-page.component';
import {ErrorPageComponent} from './components/pages/error-page/error-page.component';
import {ComingSoonPageComponent} from './components/pages/coming-soon-page/coming-soon-page.component';
import {BlogGridPageComponent} from './components/pages/blog-grid-page/blog-grid-page.component';
import {BlogRightSidebarPageComponent} from './components/pages/blog-right-sidebar-page/blog-right-sidebar-page.component';
import {BlogFullWidthPageComponent} from './components/pages/blog-full-width-page/blog-full-width-page.component';
import {BlogDetailsPageComponent} from './components/pages/blog-details-page/blog-details-page.component';
import {ShopGridPageComponent} from './components/pages/shop-grid-page/shop-grid-page.component';
import {ShopFullWidthPageComponent} from './components/pages/shop-full-width-page/shop-full-width-page.component';
import {ProductsDetailsPageComponent} from './components/pages/products-details-page/products-details-page.component';
import {CartPageComponent} from './components/pages/cart-page/cart-page.component';
import {CheckoutPageComponent} from './components/pages/checkout-page/checkout-page.component';
import {ContactPageComponent} from './components/pages/contact-page/contact-page.component';
import {CategoryPageOneComponent} from './components/pages/category-page-one/category-page-one.component';
import {CategoryPageTwoComponent} from './components/pages/category-page-two/category-page-two.component';
import {CategoryPageThreeComponent} from './components/pages/category-page-three/category-page-three.component';
import {CoursesListPageComponent} from './components/pages/courses-list-page/courses-list-page.component';
import {CoursesGridStyleOneColumnsTwoPageComponent} from './components/pages/courses-grid-style-one-columns-two-page/courses-grid-style-one-columns-two-page.component';
import {CoursesGridStyleOneColumnsThreePageComponent} from './components/pages/courses-grid-style-one-columns-three-page/courses-grid-style-one-columns-three-page.component';
import {CoursesGridStyleOneColumnsFourPageComponent} from './components/pages/courses-grid-style-one-columns-four-page/courses-grid-style-one-columns-four-page.component';
import {CoursesGridStyleTwoColumnsTwoPageComponent} from './components/pages/courses-grid-style-two-columns-two-page/courses-grid-style-two-columns-two-page.component';
import {CoursesGridStyleTwoColumnsThreePageComponent} from './components/pages/courses-grid-style-two-columns-three-page/courses-grid-style-two-columns-three-page.component';
import {CoursesGridStyleTwoColumnsFourPageComponent} from './components/pages/courses-grid-style-two-columns-four-page/courses-grid-style-two-columns-four-page.component';
import {CoursesGridStyleThreeColumnsTwoPageComponent} from './components/pages/courses-grid-style-three-columns-two-page/courses-grid-style-three-columns-two-page.component';
import {CoursesGridStyleThreeColumnsThreePageComponent} from './components/pages/courses-grid-style-three-columns-three-page/courses-grid-style-three-columns-three-page.component';
import {CoursesGridStyleThreeColumnsFourPageComponent} from './components/pages/courses-grid-style-three-columns-four-page/courses-grid-style-three-columns-four-page.component';
import {CoursesDetailsPageComponent} from './components/pages/courses-details-page/courses-details-page.component';
import {MyDashboardPageComponent} from './components/pages/my-dashboard-page/my-dashboard-page.component';
import {OrdersPageComponent} from './components/pages/orders-page/orders-page.component';
import {DownloadsPageComponent} from './components/pages/downloads-page/downloads-page.component';
import {EditAddressPageComponent} from './components/pages/edit-address-page/edit-address-page.component';
import {EditAccountPageComponent} from './components/pages/edit-account-page/edit-account-page.component';
import {EditBillingAddressPageComponent} from './components/pages/edit-billing-address-page/edit-billing-address-page.component';
import {EditShippingAddressPageComponent} from './components/pages/edit-shipping-address-page/edit-shipping-address-page.component';

import {DespreNoiComponent} from './despre-noi/despre-noi.component';
// import { CariereComponent } from './cariere/cariere.component';
import {ContactComponent} from './contact/contact.component';
import {CoronavirusComponent} from './coronavirus/coronavirus.component';
import {SpecialitatiMedicaleComponent} from './specialitati-medicale/specialitati-medicale.component';
import {LoginComponent} from './login/login.component';
import {HeaderComponent} from './blocks/header/header.component';
import {HomeComponent} from './home/home.component';
import {HomeAboutComponent} from './home/home-about/home-about.component';
import {HomeBannerComponent} from './home/home-banner/home-banner.component';
import {HomeMediciComponent} from './home/home-medici/home-medici.component';
import {BottomHooksComponent} from './blocks/bottom-hooks/bottom-hooks.component';
import {HeaderSeparatComponent} from './blocks/header-separat/header-separat.component';
import {HomeSpecialitatiComponent} from './home/home-specialitati/home-specialitati.component';
import {TarifeServiciiComponent} from './tarife-servicii/tarife-servicii.component';
import {MasuriAccesClinicaComponent} from './masuri-acces-clinica/masuri-acces-clinica.component';
import {InformatiiAccesServiciiComponent} from './informatii-acces-servicii/informatii-acces-servicii.component';
import {HeaderUserComponent} from './blocks/header-user/header-user.component';
import {ContulMeuComponent} from './contul-meu/contul-meu.component';
import {ProgramariResultsComponent} from './programari/programari-results/programari-results.component';
import {ProgramariAddComponent} from './programari/programari-add/programari-add.component';
import {ProgramariListComponent} from './programari/programari-list/programari-list.component';
import {MediciListComponent} from './medici/medici-list/medici-list.component';
import {MediciDetailComponent} from './medici/medici-detail/medici-detail.component';
import {ListSpecialitesComponent} from './specialites/list-specialites/list-specialites.component';
import {ShowSpecialtyComponent} from './specialites/show-specialty/show-specialty.component';
import {NewsListComponent} from './news/news-list/news-list.component';
import {NewsDetailComponent} from './news/news-detail/news-detail.component';
import {ListPricesComponent} from './prices/list-prices/list-prices.component';
import {ListSettledServicesComponent} from './prices/list-settled-services/list-settled-services.component';
import {SidebarSpecialitesComponent} from './blocks/sidebar-specialites/sidebar-specialites.component';
import {ListComponent} from './anunturi/list/list.component';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthGuardService} from './auth/auth-guard.service';
import {TokenInterceptor} from './auth/token.interceptor';
import {ListCareersComponent} from './careers/list-careers/list-careers.component';
import {DetailCareersComponent} from './careers/detail-careers/detail-careers.component';
import {MyTicketsComponent} from './my-tickets/my-tickets.component';
import {MyPrescriptionsComponent} from './my-prescriptions/my-prescriptions.component';
import {MyResultsComponent} from './my-results/my-results.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {CommonModule} from '@angular/common';
import {DrepturiSiObligatiiComponent} from './drepturi-si-obligatii/drepturi-si-obligatii.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { AchizitiiSiLicitatiiComponent } from './achizitii-si-licitatii/achizitii-si-licitatii.component';
import { RegisterComponent } from './register/register.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DrepturiSalarialeComponent } from './drepturi-salariale/drepturi-salariale.component';
import { ServiciiPentruPacientiComponent } from './servicii-pentru-pacienti/servicii-pentru-pacienti.component';
import { CreareContComponent } from './creare-cont/creare-cont.component';
import { PreventieSiStilDeViataSanatosComponent } from './preventie-si-stil-de-viata-sanatos/preventie-si-stil-de-viata-sanatos.component';
import { LegislatieComponent } from './legislatie/legislatie.component';
import { FormularDeEvaluareComponent } from './formular-de-evaluare/formular-de-evaluare.component';
import { ConducereSiAccesComponent } from './conducere-si-acces/conducere-si-acces.component';
import { AccessMassMediaComponent } from './access-mass-media/access-mass-media.component';
import { DeclaratiiDeAvereSiIntereseComponent } from './declaratii-de-avere-si-interese/declaratii-de-avere-si-interese.component';
import { AdaugaBiletComponent } from './adauga-bilet/adauga-bilet.component';
import { TemplateRadiologieComponent } from './template-radiologie/template-radiologie.component';
import { LegislatieCadreMedicaleComponent } from './legislatie-cadre-medicale/legislatie-cadre-medicale.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SharedResultComponent } from './shared-result/shared-result.component';


@NgModule({
    declarations: [
        AppComponent,
        HomePageOneComponent,
        HomePageTwoComponent,
        FooterComponent,
        PreloaderComponent,
        HomeoneAboutComponent,
        HomeoneMainBannerComponent,
        HeaderStyleOneComponent,
        CategoriesStyleOneComponent,
        FunfactsComponent,
        HomeoneCoursesComponent,
        PartnerStyleOneComponent,
        InstructorsStyleOneComponent,
        BecomeInstructorPartnerComponent,
        FeedbackStyleOneComponent,
        BlogComponent,
        HeaderStyleTwoComponent,
        HometwoMainBannerComponent,
        HometwoAboutComponent,
        HometwoCoursesComponent,
        OurMissionComponent,
        InstructorsStyleTwoComponent,
        WebinarCountdownComponent,
        StudentsFeedbackFormComponent,
        HomePageThreeComponent,
        HomePageFourComponent,
        HomePageFiveComponent,
        HomePageSixComponent,
        HomePageSevenComponent,
        PartnerStyleTwoComponent,
        OfferComponent,
        CategoriesStyleTwoComponent,
        HomethreeCoursesComponent,
        HomethreeAboutComponent,
        FeedbackFormComponent,
        HomethreeMainBannerComponent,
        HeaderStyleThreeComponent,
        HomefourMainBannerComponent,
        HomefourCoursesComponent,
        BoxesComponent,
        FeedbackStyleTwoComponent,
        HomefiveCoursesComponent,
        HomefiveMainBannerComponent,
        InstructorsStyleThreeComponent,
        FeaturesComponent,
        HomesixCoursesComponent,
        CategoriesStyleThreeComponent,
        HomesixMainBannerComponent,
        HeaderStyleFourComponent,
        HomesevenMainBannerComponent,
        HomesevenCoursesComponent,
        HowItWorksComponent,
        AboutPageOneComponent,
        AboutPageTwoComponent,
        OurStoryComponent,
        OurValuesComponent,
        InstructorsPageOneComponent,
        InstructorsPageTwoComponent,
        InstructorsPageThreeComponent,
        InstructorsDetailsPageComponent,
        GalleryPageComponent,
        EventsPageComponent,
        EventsDetailsPageComponent,
        PricingPageComponent,
        FeedbackPageComponent,
        PartnerPageComponent,
        LoginPageComponent,
        RegisterPageComponent,
        FaqPageComponent,
        ErrorPageComponent,
        ComingSoonPageComponent,
        BlogGridPageComponent,
        BlogRightSidebarPageComponent,
        BlogFullWidthPageComponent,
        BlogDetailsPageComponent,
        ShopGridPageComponent,
        ShopFullWidthPageComponent,
        ProductsDetailsPageComponent,
        CartPageComponent,
        CheckoutPageComponent,
        ContactPageComponent,
        CategoryPageOneComponent,
        CategoryPageTwoComponent,
        CategoryPageThreeComponent,
        CoursesListPageComponent,
        CoursesGridStyleOneColumnsTwoPageComponent,
        CoursesGridStyleOneColumnsThreePageComponent,
        CoursesGridStyleOneColumnsFourPageComponent,
        CoursesGridStyleTwoColumnsTwoPageComponent,
        CoursesGridStyleTwoColumnsThreePageComponent,
        CoursesGridStyleTwoColumnsFourPageComponent,
        CoursesGridStyleThreeColumnsTwoPageComponent,
        CoursesGridStyleThreeColumnsThreePageComponent,
        CoursesGridStyleThreeColumnsFourPageComponent,
        CoursesDetailsPageComponent,
        MyDashboardPageComponent,
        OrdersPageComponent,
        DownloadsPageComponent,
        EditAddressPageComponent,
        EditAccountPageComponent,
        EditBillingAddressPageComponent,
        EditShippingAddressPageComponent,

        DespreNoiComponent,
        // CariereComponent,
        ContactComponent,
        CoronavirusComponent,
        SpecialitatiMedicaleComponent,
        LoginComponent,
        HeaderComponent,
        HomeComponent,
        HomeAboutComponent,
        HomeBannerComponent,
        HomeMediciComponent,
        BottomHooksComponent,
        HeaderSeparatComponent,
        HomeSpecialitatiComponent,
        TarifeServiciiComponent,
        MasuriAccesClinicaComponent,
        InformatiiAccesServiciiComponent,
        HeaderUserComponent,
        ContulMeuComponent,
        ProgramariResultsComponent,
        ProgramariAddComponent,
        ProgramariListComponent,
        MediciListComponent,
        MediciDetailComponent,
        HeaderUserComponent,
        ListSpecialitesComponent,
        ShowSpecialtyComponent,
        ListPricesComponent,
        ListSettledServicesComponent,
        SidebarSpecialitesComponent,
        ListComponent,
        NewsListComponent,
        NewsDetailComponent,
        ListCareersComponent,
        DetailCareersComponent,
        MyTicketsComponent,
        MyPrescriptionsComponent,
        MyResultsComponent,
        DrepturiSiObligatiiComponent,
        ConfirmationComponent,
        AchizitiiSiLicitatiiComponent,
        RegisterComponent,
        PrivacyPolicyComponent,
        DrepturiSalarialeComponent,
        ServiciiPentruPacientiComponent,
        CreareContComponent,
        PreventieSiStilDeViataSanatosComponent,
        LegislatieComponent,
        FormularDeEvaluareComponent,
        ConducereSiAccesComponent,
        AccessMassMediaComponent,
        DeclaratiiDeAvereSiIntereseComponent,
        AdaugaBiletComponent,
        TemplateRadiologieComponent,
        LegislatieCadreMedicaleComponent,
        ForgotPasswordComponent,
        SharedResultComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CarouselModule,
        CountUpModule,
        TabsModule,
        NgxScrollTopModule,
        StickyNavModule,
        LightboxModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        ToastrModule.forRoot(),
        SlickCarouselModule,
        NgSelectModule,
         ReactiveFormsModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        AuthGuardService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
